import React from "react";
import styled from "styled-components";
import {
  FaPlug,
  FaBrain,
  FaGlobe,
  FaLaptopCode,
  FaBusinessTime,
  FaTools,
  FaCertificate,
  FaFileInvoiceDollar,
  FaUserTie,
  FaWallet
} from "react-icons/fa";
import { Helmet } from "react-helmet-async";

const Container = styled.div`
  background: ${(props) => props.theme.colors.extralight};
  color: ${(props) => props.theme.colors.dark};
  font-family: 'Trebuchet MS', sans-serif;
`;

/* Hero Section */
const Hero = styled.section`
  background: linear-gradient(135deg, #2e9694, #000);
  color: #fff;
  padding: 100px 20px;
  text-align: center;
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 10px;
`;

const HeroSubtitle = styled.p`
  font-size: 1.2rem;
`;

/* Info Section */
const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
   padding: 60px 20px 20px; 
  text-align: center;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  color: ${(props) => props.theme.colors.secondary};
  margin-bottom: 20px;
`;

const Features = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  margin-bottom: 50px;
`;

const Feature = styled.div`
  flex: 1 1 200px;
  max-width: 250px;
  padding: 20px;
  background: #fff;
  border: 1px solid ${(props) => props.theme.colors.secondary};
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(106, 138, 44, 0.3);

`;

const FeatureIcon = styled.div`
  font-size: 2.5rem;
  color: ${(props) => props.theme.colors.secondary};
  margin-bottom: 10px;
  text-align: center;
`;


const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
  margin-top: 30px;
  text-align: left;
`;

const ServiceCard = styled.div`
  background: #fff;
  border-left: 4px solid ${(props) => props.theme.colors.secondary};
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.04);
`;

const ContactSection = styled.div`
  margin-top: 60px;
  text-align: center;

  span {
    display: block;
    margin-bottom: 8px;
  }

  a {
    color: ${(props) => props.theme.colors.secondary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const AboutUs = () => {
  const services = [
    "Power Quality",
    "Power Transformers",
    "Substations & Relay Panels Consultation",
    "Smart Transformers & Monitoring",
    "Fault Analysis Services",
    "Spare Parts Supply",
    "Real Time Simulation",
    "Energy Monitoring & Billing",
    "PQ Meters, Energy Meters & Transducers",
    "BMS, IoT Integrations",
    "Custom Software & Web Solutions",
    "Third-Party Inspection & Consultation",
    "ISO Certifications & Internal Audits"
  ];

  return (
    <>
      <Helmet>
        <title>About Us | Circutech</title>
        <meta
          name="description"
          content="Learn about Circutech’s mission, vision, and team of experts providing cutting-edge electrical engineering and automation services."
        />
      </Helmet>
      <Container>
        <Hero>
          <HeroTitle>Why Choose us?</HeroTitle>
          <HeroSubtitle>Learn with purpose. Grow with confidence. Succeed with skill.</HeroSubtitle>
        </Hero>

        <Section>
          <SectionTitle>What We Do</SectionTitle>
          <Features>
            <Feature>
              <FeatureIcon><FaLaptopCode /></FeatureIcon>
              <h4>Hybrid Learning Module</h4>
              <p>Learn anytime with interactive videos, visuals, and smart digital tools.</p>
            </Feature>

            <Feature>
              <FeatureIcon><FaBusinessTime /></FeatureIcon>
              <h4>Real-Life Case Studies</h4>
              <p>Experience real business scenarios before stepping into your job.</p>
            </Feature>

            <Feature>
              <FeatureIcon><FaTools /></FeatureIcon>
              <h4>Practical-Focused Training</h4>
              <p>Master accounting skills through hands-on practice and unlimited lab access.</p>
            </Feature>

            <Feature>
              <FeatureIcon><FaCertificate /></FeatureIcon>
              <h4>Industry-Recognised Certification</h4>
              <p>Stand out with a globally valued certification from Tally Education (TEPL).</p>
            </Feature>

            <Feature>
              <FeatureIcon><FaFileInvoiceDollar /></FeatureIcon>
              <h4>GST Simulation</h4>
              <p>Learn GST filing, e-way bills, and e-invoicing in a real-like simulated setup.</p>
            </Feature>

            <Feature>
              <FeatureIcon><FaUserTie /></FeatureIcon>
              <h4>Expert Trainers with Industry Exposure</h4>
              <p>Learn from seasoned professionals with real industry and business expertise.</p>
            </Feature>

            <Feature>
              <FeatureIcon><FaWallet /></FeatureIcon>
              <h4>Affordable Fee Structure</h4>
              <p>Get job-ready skills at a student-friendly and accessible fee.</p>
            </Feature>
          </Features>



        </Section>
      </Container>
    </>
  );
};

export default AboutUs;
